export default (opts = {}) => {
  const component = {
    model: {
      
      defaults: {
        type:'link', 
        name:'Botão',
        traits: [
          {
            type:'id',
            name:'id',
            Label:'id',
          },
        ],
        components:[
          {
            type:'link',
            style: {
              'min-width': '250px',
              'font-size':'16px',
              'color': '#fff',
              'padding':'10px', 
              'display':'block',
              'box-shadow': '3px 3px 0 0px #000000 , 0px -10px 0px 0 #426bb1 inset, -3px 3px 0px  #000000',
              'border-radius': '5px', 
              'background-image': 'linear-gradient(#649dff 0%, #649dff 100%)',
              'text-align': 'center', 
              'text-decoration': 'none',
              'transition': 'all 0.5s ease'
            },
            components: [
              {
                type:'text',
                content: 'Lorem Ipsum',
            },

            ],
          },
        ],
        styles: `
        *{
          font-family: Roboto, Arial, sans-serif;
        }
       `,
      },
    },
    view: {

    },
  };

  return component;
};
